import React, { Component } from "react";

import CmsUnitSettingItem from "./CmsUnitSettingItem";
import styles from "./cmsUnitSettings.module.scss";

class CmsUnitSettingGroupItem extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { setting, onHancleChange } = this.props;

    return (
      <div className={styles.inputContainer}>
        <CmsUnitSettingItem setting={setting.item} onHancleChange={onHancleChange} key={setting.item.id} />

        {setting.dependents.length > 0 && setting.item.value.toLowerCase() === "true" ? (
          <div style={{ width: "100%" }}>
            {setting.dependents.map((item) => {
              return (
                <CmsUnitSettingItem setting={item} onHancleChange={onHancleChange} isGrouping={true} key={setting.item.value + item.id} />
              );
            })}
          </div>
        ) : null}
      </div>
    );
  }
}

export default CmsUnitSettingGroupItem;
